import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { PageHeader } from "@/components/Shared";
import { Card } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";

export default function Imports() {
  const [imports, setImports] = useState([]);
  useEffect(() => { api.get("/imports").then((r) => setImports(r.data)); }, []);
  return (
    <div>
      <PageHeader title="Storico Importazioni" subtitle="Tutte le importazioni CSV effettuate." />
      <Card className="border-slate-200 overflow-hidden">
        <Table>
          <TableHeader className="bg-slate-50"><TableRow>
            <TableHead>Data</TableHead><TableHead>File</TableHead><TableHead>Stato</TableHead>
            <TableHead>Righe inserite</TableHead><TableHead>Duplicati saltati</TableHead><TableHead>Operatore</TableHead>
          </TableRow></TableHeader>
          <TableBody>
            {imports.map((i) => (
              <TableRow key={i.id}>
                <TableCell className="text-xs font-mono text-slate-500">{new Date(i.created_at).toLocaleString("it-IT")}</TableCell>
                <TableCell className="text-sm font-medium">{i.filename}</TableCell>
                <TableCell><span className={`text-xs px-2 py-0.5 rounded-full ${i.status === "confirmed" ? "bg-emerald-50 text-emerald-700" : "bg-amber-50 text-amber-700"}`}>{i.status === "confirmed" ? "Confermata" : "In sospeso"}</span></TableCell>
                <TableCell>{i.inserted ?? "—"}</TableCell>
                <TableCell>{i.skipped_dup ?? "—"}</TableCell>
                <TableCell className="text-sm text-slate-500">{i.created_by}</TableCell>
              </TableRow>
            ))}
            {imports.length === 0 && <TableRow><TableCell colSpan={6} className="text-center text-slate-400 py-8">Nessuna importazione.</TableCell></TableRow>}
          </TableBody>
        </Table>
      </Card>
    </div>
  );
}
